export default __webpack_public_path__ + "assets/fonts/760ad4f165dfaac6d647d0c109d10653.ttf";